import React from 'react';
import './App.scss';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Cabinets from './pages/cabinets';
import Countertops from './pages/countertops';
import DomesticCountertops from './pages/domestic-countertops';
import Sinks from './pages/sinks';
import Contact from './pages/contact';
import Team from './pages/team';
import Gallery from './pages/gallery';
import CabinetDetail from './pages/cabinet-detail';
import CountertopDetail from './pages/countertop-detail';
import DomesticCountertopDetail from './pages/domestic-countertop-detail';
import SinkDetail from './pages/sink-detail';
import PageNotFound from './pages/page-not-found';
import Configure from './pages/configure';
import Flooring from './pages/flooring';
import ContractorsShowroom from './pages/contractors-showroom';

function App() {
  return (

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/cabinets'  element={<Cabinets />} />
        <Route path='/countertops'  element={<Countertops/>} />
        <Route path='/custom-countertops'  element={<DomesticCountertops/>} />
        <Route path='/sinks'  element={<Sinks/>} />
        <Route path='/contact'  element={<Contact/>} />
        <Route path='/configure' element={<Configure />} />
        <Route path='/flooring' element={<Flooring />} />
        <Route path='/contractors-showroom' element={<ContractorsShowroom />} />
        <Route path='/team'  element={<Team/>} />
        <Route path='/gallery'  element={<Gallery/>} />
        <Route path='/cabinets/:slug' element={<CabinetDetail />} />
        <Route path='/countertops/:slug' element={<CountertopDetail />} />
        <Route path='/custom-countertops/:slug' element={<DomesticCountertopDetail />} />
        <Route path='/sinks/:slug' element={<SinkDetail />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>

  );
}

export default App;
